import { render, staticRenderFns } from "./serviceAgreement.vue?vue&type=template&id=646b8fa8"
import script from "./serviceAgreement.vue?vue&type=script&lang=js"
export * from "./serviceAgreement.vue?vue&type=script&lang=js"
import style0 from "./serviceAgreement.vue?vue&type=style&index=0&id=646b8fa8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports